import React from "react";
import { useSiteMetadata } from "../hooks/use-site-metadata";
import useGoogleSheetData from "@/components/useGoogleSheet";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import LoadingSVG from "@/components/loading/loading";

function ProgramOverview() {
  const sheetId = '1i2Bw2EVK0viMttXY89PPdqjuzzazlKux8qx4aXwJvYI';
  const sheetNames = [
    'Program - Monday 15',
    'Program - Tuesday 16',
    'Program - Wednesday 17',
    'Program - Thursday 18'
  ];

  const { data, loading, error } = useGoogleSheetData(sheetId, sheetNames);

  return (
    <>
      <section>
        <div className="container px-4 md:px-6">
          <h2 className="mb-10">Please keep visiting to see program changes</h2>
          {loading && <div className="flex justify-center items-center min-h-60"><LoadingSVG /></div>}
          {error && <div>Error: {error.message}</div>}
          {!loading && !error && (
            <Tabs defaultValue={sheetNames[0]}>
              <TabsList className="grid grid-cols-4">
                {sheetNames.map((name) => (
                  <TabsTrigger key={name} value={name}>
                    {name.split(' - ')[1]}<span className="hidden lg:inline-block">, September</span>
                  </TabsTrigger>
                ))}
              </TabsList>
              {sheetNames.map((name, index) => (
                <TabsContent key={name} value={name}>
                  <Table>
                    <TableCaption className="annotation">Please note the program is subject to change</TableCaption>
                    <TableHeader>
                      <TableRow>
                        {data && data[index] && data[index].data && data[index].data.length > 0 &&
                          Object.keys(data[index].data[0]).map((key, keyIndex) => (
                            <TableHead key={key} className="bg-lteal text-white font-bold capitalize" style={keyIndex === 0 ? { width: '150px' } : {}}>
                              {key}
                            </TableHead>
                          ))
                        }
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {data && data[index] && Array.isArray(data[index].data) ? (
                        data[index].data.map((row, rowIndex) => (
                          <TableRow key={rowIndex}>
                            {Object.values(row).map((cell, cellIndex) => (
                              <TableCell key={cellIndex} className={cellIndex === 0 ? "font-bold" : ""} style={cellIndex === 0 ? { width: '150px' } : {}}>
                                {cell}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan="100%">No data available</TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TabsContent>
              ))}
            </Tabs>
          )}
        </div>
      </section>
    </>
  );
}

export default ProgramOverview;

export function Head() {
  const { title } = useSiteMetadata();
  return (
    <>
      <title>{`Program Overview - ${title}`}</title>
      <meta name="description" content="Get an overview of the program for the 5th World Conference of Women's Shelters 2025. Explore the schedule, sessions, and key topics covered." />
      <meta name="keywords" content="5WCWS, WCWS, Women's Shelters, World Conference, 2025, program overview, Conference schedule, sessions, key topics" />
    </>
  );
}
